import React from 'react';
import { SkeletonCover } from './SkeletonCover';

export const SkeletonRoute = ({ width, height, isMobile }) => (
  <div>
    {!isMobile ? (
      <div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px', marginBottom: '32px' }}
          />
        </div>
      </div>
    ) : (
      <div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px' }}
          />
        </div>
        <div>
          <SkeletonCover
            width={width}
            height={height}
            backgroundColor={'#FFFFFF'}
            animateColor={'#F3F6F9'}
            style={{ paddingTop: '8px', marginBottom: '32px' }}
          />
        </div>
      </div>
    )}
  </div>
  // <div style={{ width: '100%' }}>
  //   <ContentLoader
  //     speed={3}
  //     // width={1100}
  //     animate={animate}
  //     viewBox="0 0 1100 860"
  //     backgroundColor="#FFFFFF"
  //     foregroundColor="#F3F6F9"
  //     // style={{ maxWidth: '100%', minWidth: '100%' }}
  //     {...props}
  //   >
  //     <rect x="0" y="0" rx="0" ry="0" width={width} height={height} />
  //     <rect x="0" y="104" rx="0" ry="0" width={width} height={height} />
  //     <rect x="0" y="208" rx="0" ry="0" width={width} height={height} />
  //     <rect x="0" y="312" rx="0" ry="0" width={width} height={height} />
  //     <rect x="0" y="416" rx="0" ry="0" width={width} height={height} />
  //     <rect x="0" y="520" rx="0" ry="0" width={width} height={height} />
  //     <rect x="0" y="624" rx="0" ry="0" width={width} height={height} />
  //   </ContentLoader>
  // </div>
);
